import { titleCase } from "./capitalize";

interface FormatConfig {
  slug?: boolean;
  capitalize?: boolean;
  upperCase?: boolean;
}

export function changeSunglasses(text: string, config: FormatConfig = {}): string {
  // Regex to match variations of "non prescription sunglasses" and "non-prescription sunglasses"
  const nonPrescriptionRegex = /\b(non[-\s]?prescription[-\s]?sunglasses|non[-\s]?prescription)\b/gi;
  
  // Replace with "sunglasses" or empty string based on context
  let result = text.replace(nonPrescriptionRegex, (match) => {
    return match.toLowerCase().endsWith('sunglasses') ? 'sunglasses' : '';
  });
  
  // Clean up any double spaces that might have been created
  result = result.replace(/\s+/g, ' ').trim();
  
  // Apply formatting based on config
  if (config.slug) {
    // Convert to lowercase and replace spaces with hyphens
    result = result.toLowerCase().replace(/\s+/g, '-');
  } else if (config.upperCase) {
    // Convert to uppercase
    result = result.toUpperCase();
  } else if (config.capitalize) {
    // Capitalize first letter of each word
    result = titleCase(result);
  }
  
  return result;
}
